import { motion } from "framer-motion";
import { Heart, ArrowUpRight } from "lucide-react";
import { OmniLogo } from "./OmniLogo";
import { SUPPORT_URL } from "../../config/omni";

export const SupportCTA = () => (
  <footer
    data-testid="omni-support"
    className="relative overflow-hidden border-t border-white/10 bg-[#0a0a0b]"
  >
    <div className="absolute inset-0 omni-spotlight opacity-80" />
    <div className="relative mx-auto max-w-5xl px-5 sm:px-8 lg:px-12 py-28 sm:py-40 text-center">
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="inline-flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.24em] text-[#f5a623]"
      >
        <Heart size={13} className="fill-[#f5a623]" />
        Support the project / Sostieni il progetto
      </motion.span>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="font-display mt-8 text-5xl sm:text-7xl font-bold tracking-tight text-[#fafafa] leading-[0.95]"
      >
        Like the project.
        <span className="block text-[#8a8a92]">Metti un like.</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1 }}
        className="mx-auto mt-8 max-w-xl text-base sm:text-lg leading-relaxed text-[#c9c9cf]"
      >
        Click the button below, then on the page that opens tap the{" "}
        <Heart size={15} className="inline -translate-y-px fill-[#ff4d5e] text-[#ff4d5e]" />{" "}
        heart at the top right to give your like. No sign-up, no cost — that
        little heart is all it takes to support omni-score.
        <span className="mt-2 block text-sm italic text-[#8a8a92]">
          Clicca il pulsante qui sotto, poi nella pagina che si apre tocca il
          cuore in alto a destra per mettere il tuo like. Nessuna registrazione,
          nessun costo: quel piccolo cuore è tutto ciò che serve per sostenere
          omni-score.
        </span>
      </motion.p>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.2 }}
        className="mt-12"
      >
        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="support-cta-button"
          className="group inline-flex items-center gap-3 rounded-full bg-[#f5a623] px-9 py-5 text-[#0a0a0b] font-bold text-lg transition-transform duration-300 hover:-translate-y-1 hover:scale-[1.02] hover:shadow-[0_0_50px_-4px_rgba(245,166,35,0.7)]"
        >
          <Heart
            size={22}
            className="fill-[#0a0a0b] transition-transform duration-300 group-hover:scale-125"
          />
          Like &amp; Support omni-score
          <ArrowUpRight
            size={20}
            className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </a>
        <div className="mt-6 flex flex-col items-center gap-3">
          <p className="text-xs uppercase tracking-[0.2em] text-[#6b6b73]">
            Opens the showcase in a new tab / Si apre in una nuova scheda
          </p>
          <div
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-[#131315] px-4 py-2"
            data-testid="like-hint-chip"
          >
            <span className="text-xs text-[#8a8a92]">
              Look for this, then tap it / Cerca questo, poi toccalo
            </span>
            <span className="inline-flex items-center text-[#ff4d5e]">
              <Heart size={16} className="fill-[#ff4d5e]" />
            </span>
          </div>
        </div>
      </motion.div>
    </div>

    <div className="relative border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-5 sm:px-8 lg:px-12 py-8 sm:flex-row">
        <OmniLogo className="text-[#fafafa]" size={22} />
        <p className="text-xs text-[#6b6b73]">
          © {new Date().getFullYear()} omni-score · Built with Emergent
        </p>
      </div>
    </div>
  </footer>
);
